// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"804":"8630cbb9","855":"bda1f0ea"}[chunkId] + ".chunk.js";
};